import fileLog from "../../../services/file-log/FileLog";
import i18n from '../../../i18n/index'

export default {
  data() {
    return {
      logData: [],
      total: 0,
      pagination: {},
      search: "",
      headers: [
        {
          text: i18n.t('headers.file-name'),
          sortable: false,
          value: "plu"
        },
        {
          sortable: false,
          text: i18n.t('headers.status'),
          value: "name"
        },
        {
          sortable: false,
          text: i18n.t('headers.user'),
          value: "isWatched",
          align: "left"
        },
        {
          sortable: false,
          text: i18n.t('headers.date'),
          value: "isApplicable",
          align: "left"
        }
      ]
    };
  },
  props: {},
  watch: {
    pagination: {
      handler() {
        this.getFileLog();
      },
      deep: true
    }
  },
  created() {
    //this.getFileLog();
  },
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    },
    getFileLog () {
      const { page, rowsPerPage } = this.pagination;
      fileLog.getLog(page - 1, rowsPerPage).then(response => {
        this.logData = response.data[0];
        this.total = response.data[1];
      });
    }
  }
};
